// extracted by mini-css-extract-plugin
module.exports = {"sunBackground":"Seasonal-module--sunBackground--2GMGa","snowflakeBackground":"Seasonal-module--snowflakeBackground--3hawx"};